/**
 * @file Mode Toggle
 * @description
 * Dropdown to switch between Light, Dark, and System themes.
 */

"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function ModeToggle() {
  const { setTheme, resolvedTheme, theme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  // Prevent hydration mismatch - only show theme-specific UI after mount
  React.useEffect(() => {
    setMounted(true)
  }, [])

  // Show a placeholder during SSR to avoid layout shift
  if (!mounted) {
    return (
      <Button
        variant="ghost"
        size="icon"
        className="text-slate-600 dark:text-slate-300"
        aria-label="Cambia tema"
      >
        <Sun className="h-[1.2rem] w-[1.2rem]" aria-hidden="true" />
      </Button>
    )
  }

  const currentThemeLabel = theme === "system" ? "Sistema" : theme === "dark" ? "Scuro" : "Chiaro"

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white"
          aria-label={`Tema attuale: ${currentThemeLabel}. Clicca per cambiare tema`}
          aria-haspopup="menu"
        >
          {resolvedTheme === "dark" ? (
            <Moon className="h-[1.2rem] w-[1.2rem]" aria-hidden="true" />
          ) : (
            <Sun className="h-[1.2rem] w-[1.2rem]" aria-hidden="true" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" role="menu" aria-label="Seleziona tema">
        <DropdownMenuItem
          onClick={() => setTheme("light")}
          aria-current={theme === "light" ? "true" : undefined}
        >
          <Sun className="mr-2 h-4 w-4" aria-hidden="true" />
          Chiaro
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme("dark")}
          aria-current={theme === "dark" ? "true" : undefined}
        >
          <Moon className="mr-2 h-4 w-4" aria-hidden="true" />
          Scuro
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme("system")}
          aria-current={theme === "system" ? "true" : undefined}
        >
          <span className="mr-2 h-4 w-4 flex items-center justify-center text-xs" aria-hidden="true">💻</span>
          Sistema
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}